var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6916 0.320825L11.2786 0L10.8656 0.320825L0 8.54993L0.820234 9.63292L1.64882 9.00539V19.9999H8.90119V13.0873H13.6562V20H20.9085V9.00546L21.7371 9.63298L22.5573 8.54993L11.6916 0.320825ZM19.55 18.6414H15.0147V11.7287H7.54256V18.6414H3.00739V8.14529L11.2787 1.72028L19.55 8.14529V18.6414Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c92375452d924ea54bc7023835f1dc75.svg";
export { ForwardRef as ReactComponent };